<template>
  <v-container
    v-if="!this.$appMng.isLoadingPage"
  >
    <v-row
      align="center"
      justify="center"
    >
      <p class="title-text-size mb-2"><b>Compare os planos</b></p>
    </v-row>
    <v-row
      align="center"
      justify="center"
    >
      <p class="subtitle-text-size">Temos pacotes que se encaixam na sua necessidade.</p><br/>
    </v-row>
    <v-row
      align="center"
      justify="center"
    >
      <v-btn
        color="#25d366"
        class="mb-6 mt-2 white--text"
        :href="topButtonWhatsappUrl"
        target="_blank"
      >
        <v-icon left>mdi-whatsapp</v-icon>
        ASSINAR POR WHATSAPP
      </v-btn>
    </v-row>
  </v-container>
</template>

<script>
import {getHasPendingSubscription, listSubscription} from "../../api/api-billing"

export default {
    name: "Plans",
    data: () => ({
      isLoading: false,
    }),
    computed: {
      topButtonWhatsappUrl() {
        let whatsappSource = 'web'

        if (this.$vuetify.breakpoint.xsOnly) {
          whatsappSource = 'api'
        }

        return `https://${whatsappSource}.whatsapp.com/send?phone=5548991684709&text=Ol%C3%A1%2C%20quero%20assinar%20um%20plano%20na%20MAPPA`
      }
    },
    created() {
      this.$appMng.setTitle("Planos")
      const listSubscriptionPromise = listSubscription(this.$apiAuth.getAuthToken())
        .then(res => {
          const subscription = res.data.data[0]
          this.currentPlan.blActivated = subscription["bl_activated"]
          this.currentPlan.abSubscriptionPlan = subscription["subscription_plan"]["ab_subscription_plan"]
        })
        .catch(() => {
        })

      const getHasPendingSubscriptionPromise = getHasPendingSubscription(this.$apiAuth.getAuthToken())
        .then(res => {
          const responseData = res.data.data
          this.pendingPlan.blPendingSubscription = responseData["bl_pending_subscription"]
          this.pendingPlan.subscriptionPlan = responseData["subscription_plan"]
        })
        .catch(() => {

        })

      Promise.all([getHasPendingSubscriptionPromise, listSubscriptionPromise])
        .finally(() => {
          this.$appMng.setIsLoadingPage(false)
        })
    }
  }
</script>

<style scoped lang="scss">
  .description-list {
    list-style: none;
  }

  .card-header__pro {
    background: #12b3dd;
  }

  .card-header__business {
    background: #119cbf;
  }

  .card-header__enterprise {
    background: #117a9f;
  }

  .title-text-size {
    font-size: 35px;
  }

  .subtitle-text-size {
    font-size: 18px;
  }

</style>
